import React, { useState } from 'react';
import { functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../context/AppContext';
import Header from '../components/Header';

const WelcomePage = () => {
    const { refreshUserData } = useAppContext();
    const [displayName, setDisplayName] = useState('');
    const [country, setCountry] = useState('Australia');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleProfileSetup = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            const updateUserProfile = httpsCallable(functions, 'updateUserProfile');
            await updateUserProfile({ displayName, country, dateFormat: 'DD/MM/YYYY' });
            await refreshUserData(); // Refresh global state instead of reloading page
        } catch (err) {
            setError(err.message);
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto p-4 md:p-8">
                <Header title="Welcome to Budget Tracker!" showNav={false} />
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">Let's get you set up.</h2>
                    <p className="text-gray-600 mb-6">Welcome! To get started, please tell us a little about yourself.</p>
                    {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
                    <form onSubmit={handleProfileSetup} className="space-y-4">
                        <div>
                            <label htmlFor="displayName" className="block text-sm font-medium text-gray-700">What should we call you?</label>
                            <input type="text" id="displayName" value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" required />
                        </div>
                        <div>
                            <label htmlFor="country" className="block text-sm font-medium text-gray-700">Which country are you in?</label>
                            <select id="country" value={country} onChange={(e) => setCountry(e.target.value)} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 rounded-md">
                                <option>Australia</option><option>United Kingdom</option><option>United States</option><option>Canada</option>
                            </select>
                        </div>
                        <div className="text-right pt-4">
                            <button type="submit" disabled={isLoading} className="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300">
                                {isLoading ? 'Saving...' : 'Continue'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;